module.exports = __webpack_public_path__ + "de23a444803228e6956d26092303fc77.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/sutter_health_3_2023_chart.png
// module id = 1740
// module chunks = 0